import axios from 'axios';
import history from '../history';
import extend from 'extend';
import Authentication from '../authentication/Authentication';
import config from '../config';
import toastr from"toastr";
import ToastOptions from "../common/toast/toastr-config.js";
const auth = new Authentication();

function requestAPI(path, options) {
    let domain = config.api.host;
    let id_token = localStorage.getItem('id_token');

    let headers = {
        Authorization: "Bearer " + id_token,
        pragma: 'no-cache'
    };

    const requiredOptions = {
        url: domain + path,
        headers: headers
    };

    const params = extend(true, options, requiredOptions);

    return axios(params).then(response => {
        return Promise.resolve(response);
    }).catch(error => {
        if (!error.response || !error.response.status || error.response.status >= 500){
            console.error(error);
            console.log(error.response);
            toastr.options = ToastOptions;
            toastr.error(error);
            return Promise.reject(error);
        }

        if (error.response.status === 400) {
            console.error(error);
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            console.error(error);
            console.log(error.response);
            toastr.options = ToastOptions;
            toastr.error("Invalid access token, please log in.");
            // Clear Access Token and ID Token from local storage
            localStorage.removeItem("access_token");
            localStorage.removeItem("id_token");
            localStorage.removeItem("expires_at");
            // navigate to the index route
            history.replace("/");
            return Promise.reject(error);
        }

        if (error.response.status === 403) {
            toastr.options = ToastOptions;
            toastr.error(`Access Denied - ${error}`);
            auth.logout();
            return Promise.reject(error);
        }

        if (error.response.status === 404) {
            console.error(error.response);
            history.replace('/page-not-found');
            return Promise.reject(error);
        }

        throw error;
    });
}


export default requestAPI;


// WEBPACK FOOTER //
// ./src/services/request.js